import { H1 } from '@/components/Headings';
import { colors } from '@/styles/theme/colors';
import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

const LegalTermsHero: FC = () => {
  const { t } = useTranslation('main');

  return (
    <Stack w={'full'} align={'center'} justify={'center'} px={4}>
      <Stack
        spacing={4}
        minH={{ base: 180, lg: '2xs' }}
        align={'start'}
        justify={'end'}
        textAlign={'start'}
        w='full'
        maxW={'8xl'}
      >
        <Stack w='full' maxW={'4xl'}>
          <H1 color={colors.diment.darkBlue}>
            {t('legal-terms.hero.heading')}
          </H1>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default LegalTermsHero;
